// lib/tabSwitch.ts

let tabSWitchHandler = null

export const detectTabSwitch = (onTabSwitch) => {
  tabSWitchHandler = () => {
    if (document.hidden) {
      onTabSwitch()
    }
  }
  document.addEventListener('visibilitychange', tabSWitchHandler)
}

export const stopTabSwitchDetection = () => {
  if (tabSWitchHandler) {
    document.removeEventListener('visibilitychange', tabSWitchHandler)
    tabSWitchHandler = null
  }
}
